import { useQuery } from '@tanstack/react-query';

import { getCoreVersionInfo } from '@/lib/api/core';

export function useBackendFrontendVersion() {
  return useQuery({
    queryKey: ['core-version-info', typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown'],
    queryFn: ({ signal }) => getCoreVersionInfo(signal),
    staleTime: 60 * 1000,
    retry: 1,
  });
}

